/*
To start run "npm start" which will load page to localhost:3000
To deploy run swa build to create local package and if successful run "swa deploy --deployment-token={Azure Resource Deployment Token}"
To specify an environment add "--env={Your Environment}" to the deploy command
*/

import { useState , useEffect} from 'react'
import {ApiInterface, getApi} from "@navvis/ivion";
import styles from '../styles/app.module.css';
import logo from '../images/GridWork-Logo.png';
import logoutIcon from '../icons/logoutInverted.png';


let ivApi: ApiInterface;

export default function App(){
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    
    const initializeAPI = async (access: string, upload: string) => {
        try {               
            const api = await getApi("https://sam-llc.iv.navvis.com/", {
                loginToken: access,
                uploadToken: upload
            }).then(api => {
                ivApi = api;
            });      
        } catch (error) {
            console.error("API failed to initialize", error);
        }
    };

    const loginWithCookies = async (refresh: string) => {            
        try {          
            const accessData = await refreshAccessToken(refresh);
            const accessToken = accessData.access_token;
            const uploadToken = accessData.upload_token;
            await updateRefreshToken(refresh);
            await initializeAPI(accessToken, uploadToken);
            await revealIvion();
        }catch (error) {
            console.error(error);
            revealBackground();
        }   
    }
    
    const refreshAccessToken = async (refreshToken: string) => {
        let response = await fetch("https://sam-llc.iv.navvis.com/api/auth/refresh_access_token", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ refresh_token: refreshToken })
        });
        return await response.json();
    }

    const updateRefreshToken =  async (token: string) => {
        let refreshResponse = await fetch("https://sam-llc.iv.navvis.com/api/auth/update_refresh_token", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ 
                refresh_token: token,
                duration: 604800
            })
        });
        const responseData = await refreshResponse.json();
        const updatedToken = responseData.refresh_token;
        setCookie('refresh_token', updatedToken, 7);
    }


    const initializeLogout = () =>{
        let button = document.getElementById('logout');
        if(button){
            button.addEventListener('click', logout);
            }
        };   

        useEffect(() => {
            initializeLogout();
            const refreshToken = getCookie('refresh_token');
            if(refreshToken){
                hideBackground();
                loginWithCookies(refreshToken);
            }else{
                revealBackground();
            }
        }, []);

    const hideBackground = () =>{
        let doc2 = document.getElementById('background');
        if(doc2 != null){
            doc2.style.display = 'none';
        }
    }

    const revealBackground = () => {
        let doc2 = document.getElementById('background');
        if(doc2 != null){
            doc2.style.display = 'block';
        }
    }

    const hideIvion = () => {
        let doc = document.getElementById('ivion');
        if(doc != null){
            doc.style.visibility = 'hidden';
        }
    }

    const revealIvion = () => {
        let doc = document.getElementById('ivion');
        if(doc != null){
            doc.style.visibility ='visible';
        }  
    }

    const transitionToIvion = () =>{
        let doc3 = document.getElementById('incorrectloginmessage');
        if(doc3 != null){
            doc3.style.visibility ='hidden';
        }  
        hideBackground();
        revealIvion();
    };

    const transitionFromIvion = () => {
        hideIvion();

        resetInputFields();

        revealBackground();
    };

    

    const resetInputFields = () => {
        let emailField  = document.getElementById('emailfield') as HTMLInputElement;
        if(emailField){
         emailField.value ='';  
        }
        resetPasswordField();
    };

    const resetPasswordField = () => {
        let passwordfield = document.getElementById('passwordfield') as HTMLInputElement;
        if(passwordfield){
            passwordfield.value = '';
        }
    }

    const logout = async () => {
        try{
            if(ivApi){
                await ivApi.auth.logout();
                transitionFromIvion();

                eraseCookie('refresh_token');
            }
        }catch (error) {
            console.error("Logout failed", error);
        }     
    };

    const getTokenJson = async () => {
        try {
            const response = await fetch("https://sam-llc.iv.navvis.com/api/auth/generate_tokens", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ username, password })
            });

            if(response.status === 401){
                return null;
            }

            return await response.json(); 
        }catch (error) {
            return null;
        }   
    };

    const login = async () => {      
        try{   
                const tokenData = await getTokenJson();
                if(!tokenData){
                    let doc = document.getElementById('incorrectloginmessage');
                    if(doc != null){
                        doc.style.visibility ='visible';
                        resetPasswordField();
                    }                     
                    return;
                }
                const access_token = tokenData.access_token;
                const refresh_token = tokenData.refresh_token;
                const upload_token = tokenData.upload_token;
                
                await updateRefreshToken(refresh_token);              
                
                hideBackground();
                if(!ivApi){        
                    await initializeAPI(access_token, upload_token);
                }else{
                    try{
                        await ivApi.auth.loginWithTokens(access_token, upload_token, true);
                    }catch (error){
                        console.error(error);
                        revealBackground();
                    }
                }
                transitionToIvion();  
            }
            catch(error){

            }
    };

    const setCookie = (name: string, value: string, days: number): void => {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = `${name}=${value};${expires};path=/`;
    };
    
    const getCookie = (name: string): string | null => {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    };
    
    const eraseCookie = (name: string): void => {
        document.cookie = `${name}=; Max-Age=-99999999;`;
    };


return (
    <div>
    <div id='background' className={styles.background}> 
        <div className={styles.container}>
            <div className={styles.leftside}>
                <div className={styles.logo}></div>
                <p className={styles.welcomemessage}>Welcome back</p>
                <p className={styles.welcometext}>Welcome back! Please enter your login details.</p>
                <div>
                <input 
                    type='text' 
                    id="emailfield" 
                    className={styles.inputfield} 
                    value={username} 
                    onChange={(e) => setUsername(e.target.value)}>
                </input>
                <label className={styles.inputtext}>Username</label>
                </div>
                <div>
                <input 
                    type='password' 
                    name='password'
                    autoComplete="new-password"
                    id="passwordfield" 
                    className={styles.inputfield} 
                    value={password} 
                    onChange={(e) => setPassword(e.target.value)}>

                </input>
                <label className={styles.inputtext}>Password</label>               
                </div>
                <div id='incorrectloginmessage' className={styles.incorrectloginmessage}>
                    <p style={{fontSize: '1.4em', color:'red', paddingLeft:'325px', marginTop: '-10px'}}><b>Login is incorrect</b></p>
                </div>
                <button className={styles.loginbutton} onClick={login}><b>Sign In</b></button>
            </div>
        </div>     
    </div>
    <div id="ivion" style={{visibility: 'hidden'}}>
        <div className={styles.banner}>   
            <div style={{display: 'flex', width: '300px', height: '50px', alignItems: 'center', paddingLeft: '35px'}}>
                <img src={logo} alt='Gridworks Logo' width={300} height={50} className={styles.bannerlogo} />  
            </div>
            <div style={{display: 'flex', width: '175px', height: '50px', alignItems: 'center', justifyContent: 'end', paddingRight: '10px'}}>
                <button id="logout" title='Logout' style={{backgroundColor: '#054165', border:'none'}}><img src={logoutIcon} width={40} height={40}></img></button>
            </div>
        </div>
    {/* @ts-ignore */}
    <ivion className={styles.ivion}></ivion>
</div>
</div>
);

}